//#region src/supportedLocale.ts
var e = new Set(["pl", "en"]), t = "en";
function n(t) {
	return e.has(t);
}
//#endregion
export { t as defaultLocale, n as isSupportedLocale, e as supportedLocales };

//# sourceMappingURL=index.js.map